// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__29maf","requiredAsterisk":"Info_requiredAsterisk__13Z5j"};